import React, { useState } from 'react';
import './ES.css';
import { NavLink } from 'react-router-dom';
import { MathJax, MathJaxContext } from "better-react-mathjax";
import PageNavigator from "../../../components/PageNavigator";
// import ExampleBox from "../../../components/ExampleBox";

const priceData = [
  { day: "Day -61", stock: 10.00, market: 1000.00, industry: 500.00 },
  { day: "Day -60", stock: 9.61, market: 997.29, industry: 489.16 },
  { day: "Day -59", stock: 9.73, market: 1015.93, industry: 509.13 },
  { day: "Day -58", stock: 9.65, market: 1019.69, industry: 512.30 },
  { day: "Day -57", stock: 10.18, market: 1039.50, industry: 523.30 },
  { day: "Day -56", stock: 10.23, market: 1042.94, industry: 528.77 },
  { day: "Day -55", stock: 10.29, market: 1030.69, industry: 517.13 },
  { day: "Day -54", stock: 9.94, market: 1043.39, industry: 523.82 },
  { day: "Day -53", stock: 9.92, market: 1036.16, industry: 509.86 },
  { day: "Day -52", stock: 10.35, market: 1042.94, industry: 505.42 },
  { day: "Day -51", stock: 10.59, market: 1059.99, industry: 522.82 },
  { day: "Day -50", stock: 11.45, market: 1071.31, industry: 535.67 },
  { day: "Day -49", stock: 11.26, market: 1077.43, industry: 538.46 },
  { day: "Day -48", stock: 10.86, market: 1064.29, industry: 527.10 },
  { day: "Day -47", stock: 10.38, market: 1065.08, industry: 531.94 },
  { day: "Day -46", stock: 10.19, market: 1056.27, industry: 529.29 },
  { day: "Day -45", stock: 10.17, market: 1075.88, industry: 541.94 },
  { day: "Day -44", stock: 10.82, market: 1085.04, industry: 547.52 },
  { day: "Day -43", stock: 11.14, market: 1098.41, industry: 550.82 },
  { day: "Day -42", stock: 11.84, market: 1115.47, industry: 560.87 },
  { day: "Day -41", stock: 12.50, market: 1122.96, industry: 564.18 },
  { day: "Day -40", stock: 12.04, market: 1118.04, industry: 558.73 },
  { day: "Day -39", stock: 11.52, market: 1118.20, industry: 553.00 },
  { day: "Day -38", stock: 12.05, market: 1118.32, industry: 557.34 },
  { day: "Day -37", stock: 11.58, market: 1110.07, industry: 546.61 },
  { day: "Day -36", stock: 11.73, market: 1113.33, industry: 546.84 },
  { day: "Day -35", stock: 11.47, market: 1103.10, industry: 543.86 },
  { day: "Day -34", stock: 11.57, market: 1106.17, industry: 546.47 },
  { day: "Day -33", stock: 11.47, market: 1103.67, industry: 550.56 },
  { day: "Day -32", stock: 11.71, market: 1104.88, industry: 558.65 },
  { day: "Day -31", stock: 12.25, market: 1140.71, industry: 591.51 },
  { day: "Day -30", stock: 12.45, market: 1135.96, industry: 589.28 },
  { day: "Day -29", stock: 12.44, market: 1150.12, industry: 596.77 },
  { day: "Day -28", stock: 12.46, market: 1134.42, industry: 585.06 },
  { day: "Day -27", stock: 12.17, market: 1142.82, industry: 587.81 },
  { day: "Day -26", stock: 12.20, market: 1156.82, industry: 591.67 },
  { day: "Day -25", stock: 12.11, market: 1162.20, industry: 604.93 },
  { day: "Day -24", stock: 12.24, market: 1162.69, industry: 608.09 },
  { day: "Day -23", stock: 12.31, market: 1171.94, industry: 622.45 },
  { day: "Day -22", stock: 12.90, market: 1189.84, industry: 644.19 },
  { day: "Day -21", stock: 13.63, market: 1229.58, industry: 668.76 },
  { day: "Day -20", stock: 13.02, market: 1212.71, industry: 655.88 },
  { day: "Day -19", stock: 12.89, market: 1220.18, industry: 654.04 },
  { day: "Day -18", stock: 13.22, market: 1242.32, industry: 668.63 },
  { day: "Day -17", stock: 13.28, market: 1256.39, industry: 672.70 },
  { day: "Day -16", stock: 13.95, market: 1282.87, industry: 709.17 },
  { day: "Day -15", stock: 14.52, market: 1305.60, industry: 726.21 },
  { day: "Day -14", stock: 14.52, market: 1309.16, industry: 720.97 },
  { day: "Day -13", stock: 14.95, market: 1312.30, industry: 723.05 },
  { day: "Day -12", stock: 14.44, market: 1294.46, industry: 718.05 },
  { day: "Day -11", stock: 14.85, market: 1285.27, industry: 714.44 },
  { day: "Day -10", stock: 14.17, market: 1276.40, industry: 692.81 },
  { day: "Day -9", stock: 15.41, market: 1305.02, industry: 731.19 },
  { day: "Day -8", stock: 16.08, market: 1322.05, industry: 747.27 },
  { day: "Day -7", stock: 16.43, market: 1309.71, industry: 734.57 },
  { day: "Day -6", stock: 17.03, market: 1314.26, industry: 732.23 },
  { day: "Day -5", stock: 17.73, market: 1316.38, industry: 729.07 },
  { day: "Day -4", stock: 17.04, market: 1312.45, industry: 724.85 },
  { day: "Day -3", stock: 16.39, market: 1302.03, industry: 722.77 },
  { day: "Day -2", stock: 15.94, market: 1291.63, industry: 720.87 },
  { day: "Day -1", stock: 17.12, market: 1324.97, industry: 747.06 },
  { day: "Day 0", stock: 15, market: 1296.77, industry: 722.77 },
];

const returnData = priceData.map((row, i) => {

    if(i===0){
        return {
            ...row,
            stockReturn:null,
            marketReturn:null,
            industryReturn:null
        };
    }

    const prev = priceData[i-1];

    return {

        ...row,

        stockReturn:
            (row.stock-prev.stock)/prev.stock,

        marketReturn:
            (row.market-prev.market)/prev.market,

        industryReturn:
            (row.industry-prev.industry)/prev.industry
    };

});

const alpha = 0.000327117;
const betaMarket = 1.265384337;
const betaIndustry = 0.474129409;

const regressionSE = 0.027715512;

const event = returnData[61];

const predictedReturn =
    alpha
    + betaMarket*event.marketReturn
    + betaIndustry*event.industryReturn;

const abnormalReturn =
    event.stockReturn
    - predictedReturn;

const tStat =
    abnormalReturn/regressionSE;

function ES2() {
  return (
        <div className='ES'>
        <PageNavigator group="ES" />
        <p className='heading1'>Event Study Example</p>
        <MathJaxContext>
            <p className='heading2'>Big Pharma Co.</p>
            <p>
            Suppose Big Pharma Co. announces on Day 0 that its leading drug failed to receive FDA approval. We want to estimate how much of the stock price reaction was caused by this announcement.
            </p>
            <p>
            We start with return data for Big Pharma Co., a market index, and a pharma industry index. 
            </p>
        <div className="table-wrapper">
        <table className="my-table">
            <thead>
                <tr>
                    <th className="table-entry-head">Day</th>
                    <th className="table-entry-head">Stock Return</th>
                    <th className="table-entry-head">Market Return</th>
                    <th className="table-entry-head">Industry Return</th>
                </tr>
            </thead>

            <tbody>
                {returnData
                    // 1. Filter out any row where any of the returns are null
                    .filter(row => row.stockReturn !== null && row.marketReturn !== null && row.industryReturn !== null)
                    // 2. Map only the valid rows
                    .map((row, index) => (
                        <tr
                            className={`table-row ${row.day === "Day 0" ? "event-row" : ""}`}
                            key={index}
                        >
                            <td className="table-entry">{row.day}</td>

                            {/* 3. You can safely call .toFixed(4) directly now */}
                            <td className="table-entry">
                                {row.stockReturn.toFixed(4)}
                            </td>

                            <td className="table-entry">
                                {row.marketReturn.toFixed(4)}
                            </td>

                            <td className="table-entry">
                                {row.industryReturn.toFixed(4)}
                            </td>
                        </tr>
                    ))}
            </tbody>
        </table>
        </div>
        <p className='heading2'>Regression</p>
        <p>Using the daily return data from day -60 to day -1, we estimate the following regression:
        <MathJax className='math-container'>
          {`\\[
            \\begin{aligned}
                R_t = \\alpha + \\beta_{\\text{Market}}R_{mt} + \\beta_{\\text{Industry}}R_{it} + \\varepsilon_t
            \\end{aligned}
          \\]`}   
        </MathJax> 
        This gives us the following parameter estimates:
        <MathJax className='math-container'>
          {`\\[
            \\begin{aligned}
                \\hat \\alpha &= ${alpha.toFixed(4)} \\\\
                \\hat \\beta_{\\text{Market}} &= ${betaMarket.toFixed(2)} \\\\
                \\hat \\beta_{\\text{Industry}} &= ${betaIndustry.toFixed(2)}
            \\end{aligned}
          \\]`} 
        </MathJax>   
        Additionally, the standard error of this regression is 
        <MathJax className='math-container'>
          {`\\[
            \\begin{aligned}
                SE = ${regressionSE.toFixed(3)}
            \\end{aligned}
          \\]`} 
        </MathJax>  
        </p>
        <p className='heading2'>Predicted Return</p>
        <p>
        We use our parameter estimates and the actual market and industry returns on the event date to predict Big Pharma Co.'s return on the event date.
        <MathJax>
        {`
        \\[
        \\begin{aligned}
        \\hat R_0 
        &= \\hat \\alpha + \\hat \\beta_{\\text{Market}}R_{m0} + \\hat \\beta_{\\text{Industry}}R_{i0} \\\\
        &=
        ${alpha.toFixed(4)}
        +
        (${betaMarket.toFixed(2)})(${event.marketReturn.toFixed(4)})
        +
        (${betaIndustry.toFixed(2)})(${event.industryReturn.toFixed(4)})
        \\\\
        &=
        ${predictedReturn.toFixed(3)}
        \\end{aligned}
        \\]
        `}
        </MathJax>
        </p>
        <p className='heading2'>Abnormal Return</p>
        <p>
        Using the actual return on the event date and the predicted return on the event date, we can find the abnormal return.
        <MathJax>
        {`
        \\[
        \\begin{aligned}
        AR
        &=
        R_0-\\hat R_0
        \\\\
        &=
        ${event.stockReturn.toFixed(4)}
        -
        (${predictedReturn.toFixed(4)})
        \\\\
        &=
        ${abnormalReturn.toFixed(4)}
        \\end{aligned}
        \\]
        `}
        </MathJax>
        </p>
        <p className='heading2'>t-Statistic</p>
        <p>
        We estimate the t-statistic using the abnormal return and the standard error of the training regression.
        <MathJax>
        {`
        \\[
        \\begin{aligned}
        t
        &=
        \\frac{AR}{SE}
        \\\\
        &=
        \\frac{${abnormalReturn.toFixed(4)}}{${regressionSE.toFixed(4)}}
        \\\\
        &=
        ${tStat.toFixed(2)}
        \\end{aligned}
        \\]
        `}
        </MathJax>
        </p>
        <p className='heading2'>Statistical Significance</p>
        <p>
        Since <MathJax inline>{`\\(|t|=${Math.abs(tStat).toFixed(2)}\\)`}</MathJax> is greater than 1.96, we conclude that the abnormal return is statistically
        significant at the 5% level.
        </p>
        </MathJaxContext>
        <PageNavigator group="ES"/>
        </div>
  );
}

export default ES2;